import { render, staticRenderFns } from "./AdsResponsive.vue?vue&type=template&id=5d0776b4&scoped=true"
import script from "./AdsResponsive.vue?vue&type=script&lang=ts"
export * from "./AdsResponsive.vue?vue&type=script&lang=ts"
import style0 from "./AdsResponsive.vue?vue&type=style&index=0&id=5d0776b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0776b4",
  null
  
)

export default component.exports